export const isValidMedicareNumber = (value: any): boolean => {
  if (!value || !value[0]) {
    return true;
  }

  const fullString = value[0].toString().replace(/ /g, "");
  if (!(/\d{10}/.test(fullString) && fullString[0].match(/[2-6]/) !== null)) {
    return false;
  }

  const PATTERN = /^(\d{8})(\d)/;
  const multipliers = [1, 3, 7, 9, 1, 3, 7, 9];

  if (fullString.length === 10) {
    const matches = PATTERN.exec(fullString);
    if (matches) {
      const base = matches[1];
      const checkDigit = matches[2];
      let total = 0;

      for (let i = 0; i < multipliers.length; i++) {
        total += Number(base[i]) * multipliers[i];
      }
      return total % 10 === Number(checkDigit);
    }
  }

  return false;
};

export const isValidMedicareNumberWithIrn = (value: any): boolean => {
  if (!value || !value[0]) {
    return true;
  }

  const fullString = value[0].toString().replace(/ /g, "");

  if (fullString.length !== 11) {
    return false;
  }

  return isValidMedicareNumber([fullString.substring(0, 10)]);
};
